module.exports = __webpack_public_path__ + "static/media/bingo-ball_02.1a8ebc26.png";